import React from "react";
import { useParams } from "react-router-dom";

import { useTranslate } from "localization";
import { Filter } from "ui/forms";

import { skipToken, useSubmissionSlotsStatusQuery } from "API";

import useFilterParam from "./useFilterParam";

interface SubmissionSlotsStatusProps {
  groupId?: string;
}

const SubmissionSlotsStatus: React.FC<SubmissionSlotsStatusProps> = ({
  groupId,
}) => {
  const { translate } = useTranslate();
  const title = translate("status");
  const { submissionGroupId } = useParams();

  const submissionGroupIdToUse = groupId || submissionGroupId;

  const {
    data = [],
    isSuccess,
    isError,
  } = useSubmissionSlotsStatusQuery(
    submissionGroupIdToUse ? { groupId: submissionGroupIdToUse } : skipToken
  );
  const [selected, setSelected] = useFilterParam(
    "submission_slots_status",
    data,
    {
      defaultToFirst: false,
      multi: true,
      ready: isSuccess || isError,
    }
  );
  return (
    <Filter
      items={{ options: data }}
      title={title}
      label={title}
      selected={!!selected.length}
      count={selected.length ? selected.length : void 0}
      onChange={setSelected}
      disabled={!data.length || !selected}
      value={selected}
      multi={true}
      showReset={true}
      showApply={true}
      searchable={true}
      translate={translate}
    />
  );
};

export default SubmissionSlotsStatus;
